module.exports = "<p>\r\n  vendor-details works!\r\n</p>\r\n"